export enum KeyValueViewType {
  iconOnly = 1,
  textOnly = 2,
  iconAndText = 3,
  imageOnly = 4,
  imageAndText = 5,
}
